module.exports = __webpack_public_path__ + "img/glodal-var.116498f4.svg";